<template>
  <div class="container-md plr-0">
    <div class="container-bg p-4 com-attent-wrap dash-npd">
      <div class="row mb-3">
        <div class="col-md-12 col-12">
          <div class="d-flex">
            <h4 class="mr-auto">
              <span>Absenties rapportage</span>
            </h4>
            <div>
              <button
                class="btn btc-sm btn-dark"
                style="font-size: 13px !important"
                @click="downloadResults()"
              >
                <span v-if="!pdf_loading"> Downloaden </span>
                <span v-else> Downloading... </span>
              </button>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-2 col-4 float-md-left float-right">
                    <button class="btn btn-dark ml-3" v-if="filtered">Export</button>
                </div> -->
      </div>

      <div class="row">
        <div class="col-12">
          <table class="table">
            <tr v-if="!loadGroepen" class="pr-0">
              <th>Commissie:</th>
              <td colspan="2">
                <select2
                  @change="selectCommittee()"
                  :options="
                    [{ id: 0, text: 'Alle Commissies' }].concat(
                      committees.map((d) => {
                        return { id: d.id, text: d.title };
                      })
                    )
                  "
                  v-model="selected_committee_id"
                  class=""
                />
              </td>
              <td class="pr-0 d-flex justify-content-end">
                <button
                  class="btn btn-sm btn-dark text-white mt-0"
                  style="font-size: 13px !important"
                  @click="swithToGroups(true)"
                >
                  Groepen
                </button>
              </td>
            </tr>

            <tr v-else>
              <th>Groep:</th>
              <td colspan="2">
                <select2
                  @change="selectGroup()"
                  :options="
                    [{ id: 0, text: 'Alle Groepen' }].concat(
                      groups.map((d) => {
                        return { id: d.id, text: d.title };
                      })
                    )
                  "
                  v-model="selected_group_id"
                  class=""
                />
              </td>
              <td class="pr-0 d-flex justify-content-end">
                <button
                  class="btn btn-sm btn-dark text-white mt-0"
                  @click="swithToGroups(false)"
                  style="font-size: 13px !important"
                >
                  Commissies
                </button>
              </td>
            </tr>

            <tr>
              <th>Gebruiker</th>
              <td colspan="2">
                <select2
                  @change="getUserEvents()"
                  :options="
                    [{ id: 0, text: 'Alle Leden' }].concat(
                      users.map((d) => {
                        return { id: d.id, text: d.display_name };
                      })
                    )
                  "
                  v-model="selected_user_id"
                />
              </td>
            </tr>

            <tr>
              <th>Van tot datum:</th>
              <td>
                <input
                  @change="getUserEvents()"
                  v-model="filter.date_start"
                  type="datetime-local"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  @change="getUserEvents()"
                  v-model="filter.date_end"
                  type="datetime-local"
                  class="form-control"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- Option 1: 
                If 1 user was selected
                list all events the user was attached to in the given period.

             -->
      <div class="row" v-if="display_user_event">
        <div class="col-12">
          <h1 v-if="selected_user">{{ selected_user.display_name }}</h1>
          <!-- user.display_name -->
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Datum</th>
                <!-- date -->
                <th>Commissie</th>
                <!-- committee -->
                <th>Aanwezig</th>
                <!-- attended yes/no (show: Ja/Nee) -->
                <th>Geannuleerd</th>
                <!-- Cancelled yes/no (show Ja/Nee) -->
                <th>Opmerkingen</th>
                <!-- remarks -->
                <th>Afgetekend op</th>
                <!-- attandance_filled date -->
              </tr>
            </thead>
            <tbody v-if="fetching_user_events || user_events.length == 0">
              <tr v-if="fetching_user_events">
                <td colspan="3">Laden..</td>
              </tr>
              <tr v-else-if="user_events.length == 0">
                <td colspan="3">Niets gevonden...</td>
              </tr>
            </tbody>
            <tbody v-else>
              <!-- list events -->
              <tr v-for="(event, index) in user_events" :key="index">
                <th>
                  <a :href="'/community/events/' + event.id + '/absentie'"
                    ><i class="fas fa-edit"></i
                  ></a>
                </th>
                <th>{{ event.date_start | formatDate }}</th>
                <th>
                  <ul class="m-0 p-0">
                    <li
                      v-for="(committee, index) in event.committees"
                      :key="index"
                    >
                      <a :href="'/committees/' + committee.id + '/view'">{{
                        committee.title
                      }}</a>
                    </li>
                  </ul>
                </th>
                <th>
                  <span v-if="event.pivot.attend == 1">Ja</span>
                  <span v-else>Nee</span>
                </th>
                <th>
                  <span v-if="event.canceled == 1">Ja</span>
                  <span v-else>Nee</span>
                </th>
                <td>
                  <div v-if="event.remarks != null">
                    <button
                      @click="event_remark = event.remarks"
                      class="btn btn-dark btn-sm text-white"
                      data-toggle="modal"
                      data-target="#remarkModal"
                    >
                      Bekijk
                    </button>
                  </div>
                </td>
                <td>
                  <div v-if="event.attandance_filled != null">
                    {{ event.attandance_filled | formatDate }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 
                Option 2
                if all committees are selected use this report
            -->
      <div class="row" v-if="display_all_committee_event">
        <div class="col-12">
          Alle Commissies
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Titel</th>
                <th>Datum</th>
                <!-- date -->
                <!-- <th>Commissie</th> -->
                <!-- committee -->
                <!-- <th>Aantal aanwezig/afwezig</th> -->
                <!-- number of people attanded / absent-->
                <th>Geannuleerd</th>
                <!-- cacelled -->
                <th>Opmerkingen</th>
                <!-- remarks -->
                <th>Afgetekend op</th>
                <!-- attandance_filled date -->
                <th>openen</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="fetching_committee_events">
                <td colspan="3">Aan het laden...</td>
              </tr>
              <!-- li1st all events -->
              <tr v-for="(event, index) in committee_events" :key="index">
                <td>
                  <a :href="'/community/events/' + event.id + '/absentie'"
                    ><i class="fas fa-edit"></i
                  ></a>
                </td>
                <td>{{ event.title }}</td>
                <td>{{ event.date_start | formatDate }}</td>
                <th></th>
                <td>
                  <span v-if="event.canceled == 1">Ja</span>
                  <span v-else>Nee</span>
                </td>
                <td>
                  <div v-if="event.attandance_filled != null">
                    {{ event.attandance_filled | formatDate }}
                  </div>
                </td>
                <td>
                  <div v-if="event.remarks != null">
                    <button
                      @click="event_remark = event.remarks"
                      class="btn btn-dark btn-sm text-white"
                      data-toggle="modal"
                      data-target="#remarkModal"
                    >
                      Bekijk
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- option *-
            3:
                if 1 committee: -->
      <div class="row" v-if="display_committee_event">
        <div class="col-12">
          <h1>{{ selected_committee.title }}</h1>
          <table class="table">
            <thead>
              <tr>
                <td></td>
                <td>Titel</td>
                <td>Datum</td>
                <!-- date -->
                <td>Geannuleerd</td>
                <!-- cancelled -->
                <td>Afgetekend op</td>
                <!-- attandance_filled date -->
                <td>Opmerking</td>
                <!-- remarks -->
              </tr>
            </thead>
            <tbody>
              <tr v-if="fetching_user_events">
                <td colspan="3">Aan het laden...</td>
              </tr>
              <!-- li1st all events -->
              <tr v-for="(event, index) in committee_events" :key="index">
                <td>
                  <a :href="'/community/events/' + event.id + '/absentie'"
                    ><i class="fas fa-edit"></i
                  ></a>
                </td>
                <td>{{ event.title }}</td>
                <td>{{ event.date_start | formatDate }}</td>
                <td>
                  <span v-if="event.canceled == 1">Ja</span>
                  <span v-else>Nee</span>
                </td>
                <td>
                  <div v-if="event.attandance_filled != null">
                    {{ event.attandance_filled | formatDate }}
                  </div>
                </td>
                <td>
                  <div v-if="event.remarks != null">
                    <button
                      @click="event_remark = event.remarks"
                      class="btn btn-dark btn-sm text-white"
                      data-toggle="modal"
                      data-target="#remarkModal"
                    >
                      Bekijk
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table">
            <thead>
              <tr>
                <th>Lid</th>
                <!-- member -->
                <th v-for="(event, index) in committee_events" :key="index">
                  {{ event.date_start | formatDate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(member, index) in orderByLastname(getAttendees)"
                :key="index"
              >
                {{
                  member.display_name
                }}
                <td
                  v-for="(event, index) in committee_events"
                  :key="index"
                  class=""
                >
                  <span v-html="getMemberEventStatus(event, member.id)"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 
                Option 4
                if all groups are selected use this report
            -->
      <div class="row" v-if="display_all_group_event">
        <div class="col-12">
          Alle Groepen
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Titel</th>
                <th>Datum</th>
                <!-- date -->
                <th>Geannuleerd</th>
                <!-- cacelled -->
                <th>Afgetekend op</th>
                <!-- attandance_filled date -->
                <th>Opmerkingen</th>
                <!-- remarks -->
              </tr>
            </thead>
            <tbody>
              <tr v-if="fetching_group_events">
                <td colspan="3">Aan het laden...</td>
              </tr>
              <!-- li1st all events -->
              <tr v-for="(event, index) in group_events" :key="index">
                <td>
                  <a :href="'/community/events/' + event.id + '/absentie'"
                    ><i class="fas fa-edit"></i
                  ></a>
                </td>
                <td>{{ event.title }}</td>
                <td>{{ event.date_start | formatDate }}</td>
                <td>
                  <span v-if="event.canceled == 1">Ja</span>
                  <span v-else>Nee</span>
                </td>
                <td>
                  <div v-if="event.attandance_filled != null">
                    {{ event.attandance_filled | formatDate }}
                  </div>
                </td>
                <td>
                  <div v-if="event.remarks != null">
                    <button
                      @click="event_remark = event.remarks"
                      class="btn btn-dark btn-sm text-white"
                      data-toggle="modal"
                      data-target="#remarkModal"
                    >
                      Bekijk
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- option *-
            5:
                if 1 groep: -->
      <div class="row" v-if="display_group_event">
        <div class="col-12">
          <h1>{{ selected_group.title }}</h1>
          <table class="table">
            <thead>
              <tr>
                <td></td>
                <td>Titel</td>
                <td>Datum</td>
                <!-- date -->
                <td>Geannuleerd</td>
                <!-- cancelled -->
                <td>Afgetekend op</td>
                <!-- attandance_filled date -->
                <td>Opmerking</td>
                <!-- remarks -->
              </tr>
            </thead>
            <tbody>
              <tr v-if="fetching_user_events">
                <td colspan="3">Aan het laden...</td>
              </tr>
              <!-- li1st all events -->
              <tr v-for="(event, index) in group_events" :key="index">
                <td>
                  <a :href="'/community/events/' + event.id + '/absentie'"
                    ><i class="fas fa-edit"></i
                  ></a>
                </td>
                <td>{{ event.title }}</td>
                <td>{{ event.date_start | formatDate }}</td>
                <td>
                  <span v-if="event.canceled == 1">Ja</span>
                  <span v-else>Nee</span>
                </td>
                <td>
                  <div v-if="event.attandance_filled != null">
                    {{ event.attandance_filled | formatDate }}
                  </div>
                </td>
                <td>
                  <div v-if="event.remarks != null">
                    <button
                      @click="event_remark = event.remarks"
                      class="btn btn-dark btn-sm text-white"
                      data-toggle="modal"
                      data-target="#remarkModal"
                    >
                      Bekijk
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table">
            <thead>
              <tr>
                <th>Lid</th>
                <!-- member -->
                <th v-for="(event, index) in group_events" :key="index">
                  {{ event.date_start | formatDate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(member, index) in orderByLastname(getAttendees)"
                :key="index"
              >
                {{
                  member.display_name
                }}
                <td
                  v-for="(event, index) in group_events"
                  :key="index"
                  class=""
                >
                  <span v-html="getMemberEventStatus(event, member.id)"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="remarkModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="remarkModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: unset">
            <div>
              <h4><span>Opmerking</span></h4>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 opmerkingenCol">
                <p v-html="event_remark"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { mapActions } from "vuex";

export default {
  name: "members",
  data() {
    return {
      committees: [],
      groups: [],
      users: [],
      filtered: false,
      filter: {
        date_start: "",
        date_end: "",
        committee: 0,
      },
      display_committee_event: false,
      display_group_event: false,
      display_user_event: false,
      fetching_user_events: false,
      fetching_committee_events: false,
      fetching_group_events: true,
      user_events: [],
      committee_events: [],
      group_events: [],
      selected_user_id: 0,
      selected_user: {},
      selected_committee_id: 0,
      selected_group_id: 0,
      selected_committee: {},
      selected_group: {},
      display_all_committee_event: 0,
      display_all_group_event: 1,
      all_events_attendees: [],
      today: null,
      tmp_committee_users: [],
      tmp_group_users: [],
      event_remark: null,
      loadGroepen: true,
      pdf_loading: false,
    };
  },
  watch: {
    tmp_committee_users(val) {
      //this.users = this.tmp_group_users.concat(val)
      this.users = val;
    },
    tmp_group_users(val) {
      //this.users = this.tmp_committee_users.concat(val);
      this.users = val;
    },
    selected_committee_id(newValue) {
      if (newValue == 0) {
        var tmp = [];
        this.committees.forEach((d) => {
          tmp = [...tmp, ...d.users];
        });
        this.tmp_committee_users = tmp;
        return false;
      }
      var temp = this.committees.find((d) => d.id == newValue);
      //this.users = [];
      var selectedUser = temp.users.find((u) => u.id == this.selected_user_id);
      if (!selectedUser) {
        this.display_user_event = false;
        this.selected_user_id = 0;
        this.selected_user = {};
      }
      this.tmp_committee_users = temp.users;
    },
    selected_group_id(newValue) {
      if (newValue == 0) {
        var tmp = [];
        this.groups.forEach((d) => {
          tmp = [...tmp, ...d.users];
        });
        this.tmp_group_users = tmp;
        return false;
      }
      var temp = this.groups.find((d) => d.id == newValue);
      //this.users = [];
      //display_user_event
      var selectedUser = temp.users.find((u) => u.id == this.selected_user_id);
      if (!selectedUser) {
        this.display_user_event = false;
        this.selected_user_id = 0;
        this.selected_user = {};
      }

      this.tmp_group_users = temp.users;
    },
  },
  methods: {
    ...mapActions({
      displayNotification: "auth/displayNotification",
    }),
    orderByLastname(users) {
      return users.sort((a, b) => a.lastname.localeCompare(b.lastname));
    },
    downloadResults() {
      this.pdf_loading = true;
      let selectedCommittee = this.committees.find(
        (c) => c.id == this.selected_committee_id
      );
      let selectedGroup = this.groups.find(
        (g) => g.id == this.selected_group_id
      );
      let selectedUser = this.users.find((u) => u.id == this.selected_user_id);
      axios
        .post(
          process.env.VUE_APP_API_BASE_URL + `/api/v1/attendance/pdf`,
          {
            selectedCommittee: selectedCommittee
              ? selectedCommittee.title
              : "All Committees",
            selectedGroup: selectedGroup ? selectedGroup.title : "All Groups",
            loadGroepen: this.loadGroepen,
            selectedUser: selectedUser ? selectedUser.display_name : "",
            filterDateStart: this.filter.date_start,
            filterDateEnd: this.filter.date_end,
            fetching_user_events: this.fetching_user_events,
            user_events: this.user_events,
            display_user_event: this.display_user_event,
            display_all_committee_event: this.display_all_committee_event,
            fetching_committee_events: this.fetching_committee_events,
            committee_events: this.committee_events,
            display_committee_event: this.display_committee_event,
            getAttendees: this.getAttendees,
            display_all_group_event: this.display_all_group_event,
            fetching_group_events: this.fetching_group_events,
            group_events: this.group_events,
            display_group_event: this.display_group_event,
          },
          {
            responseType: "blob",
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          console.log(data);
          this.displayNotification({
            type: "success",
            title: "Report",
            message: "Het verslag zal u spoedig per e-mail worden toegezonden",
          });
          this.pdf_loading = false;

          /* const type = data.headers["content-type"];
                        const blob = new File([data.data], { type: type });
                        const link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = "pdf.pdf";
                        link.click(); */
        })
        .catch((error) => {
          console.log(error);
          this.pdf_loading = false;
        });
    },
    swithToGroups(loadGroepen) {
      this.display_all_group_event = false;
      this.display_group_event = false;
      this.display_all_committee_event = false;
      this.fetching_committee_events = false;
      if (!loadGroepen) {
        this.display_all_committee_event = true;
        this.fetching_committee_events = true;
        this.selectCommittee();
      } else {
        this.display_all_group_event = true;
        this.fetching_group_events = true;
        this.selectGroup();
      }

      this.display_committee_event = false;
      this.loadGroepen = loadGroepen;
      this.selected_committee_id = 0;
      this.selected_group_id = 0;
    },
    filterEventsByDate(data) {
      let events = data;
      if (this.filter.date_start != "") {
        events = data.filter((item) => {
          return moment(this.filter.date_start).isBefore(
            moment(item.date_start)
          );
        });
      }

      if (this.filter.date_end != "") {
        events = data.filter((item) => {
          return moment(this.filter.date_end).isAfter(moment(item.date_end));
        });
      }

      return events;
    },
    getMemberEventStatus(event, member_id) {
      var result = "-";
      var member = event.attendees.find((d) => d.id == member_id);
      if (member) {
        if (member.pivot.attend == 1) result = "Ja";
        else result = "Nee";
      }
      return result;
    },
    selectCommittee() {
      this.display_all_group_event = false;
      this.display_group_event = false;

      this.events = [];

      /* this.selected_user_id = 0;
                this.selected_user = {}; */

      if (this.selected_committee_id == 0) {
        this.display_all_committee_event = true;
        this.display_committee_event = false;
      } else {
        this.display_all_committee_event = false;
        this.display_committee_event = true;
      }

      this.selected_committee = this.committees.find(
        (d) => d.id == this.selected_committee_id
      );

      this.fetching_committee_events = true;
      this.$store
        .dispatch(
          "get",
          "/api/v1/events/parent-id/3/committee/" + this.selected_committee_id
        )
        .then((data) => {
          this.fetching_committee_events = false;
          let commissies = data.data.sort((a, b) =>
            moment(a.date_start).isAfter(moment(b.date_start))
              ? 1
              : moment(b.date_start).isAfter(moment(a.date_start))
              ? -1
              : 0
          );
          this.committee_events = this.filterEventsByDate(commissies);
          var temp = [];
          data.data.forEach((element) => {
            temp = [...temp, ...element.attendees];
          });

          this.all_events_attendees = temp;
        })
        .catch((error) => {
          this.fetching_committee_events = false;
          console.log(error.request);
        });
    },
    selectGroup() {
      this.display_all_committee_event = false;
      this.display_committee_event = false;

      this.events = [];
      /* this.selected_user_id = 0;
                this.selected_user = {}; */

      if (this.selected_group_id == 0) {
        this.display_all_group_event = true;
        this.display_group_event = false;
      } else {
        this.display_all_group_event = false;
        this.display_group_event = true;
      }

      this.selected_group = this.groups.find(
        (d) => d.id == this.selected_group_id
      );

      this.fetching_group_events = true;
      this.$store
        .dispatch(
          "get",
          "/api/v1/events/parent-id/2/committee/" + this.selected_group_id
        )
        .then((data) => {
          this.fetching_group_events = false;
          let groups = data.data.sort((a, b) =>
            moment(a.date_start).isAfter(moment(b.date_start))
              ? 1
              : moment(b.date_start).isAfter(moment(a.date_start))
              ? -1
              : 0
          );
          this.group_events = this.filterEventsByDate(groups);
          var temp = [];
          data.data.forEach((element) => {
            temp = [...temp, ...element.attendees];
          });
          this.all_events_attendees = temp;
        })
        .catch((error) => {
          this.fetching_group_events = false;
          console.log(error.request);
        });
    },
    getUserEvents() {
      this.display_committee_event =
        !this.loadGroepen && this.selected_committee_id != 0;
      this.display_all_committee_event =
        !this.loadGroepen && this.selected_committee_id == 0;

      this.display_group_event =
        this.loadGroepen && this.selected_group_id != 0;
      this.display_all_group_event =
        this.loadGroepen &&
        this.selected_group_id == 0 &&
        this.display_all_group_event;

      this.display_user_event = false;
      this.selected_user = this.users.find(
        (d) => d.id == this.selected_user_id
      );

      if (this.selected_user_id && this.selected_user_id != 0) {
        this.fetching_user_events = true;
        this.$store
          .dispatch(
            "get",
            "/api/v1/events/user/" +
              this.selected_user_id +
              "?date_start=" +
              this.filter.date_start +
              "&date_end=" +
              this.filter.date_end
          )
          .then((data) => {
            if (data.data) {
              this.user_events = data.data;
            } else {
              this.user_events = [];
            }
            this.fetching_user_events = false;
            this.display_user_event = true;
          })
          .catch((error) => {
            this.fetching_user_events = false;
            this.user_events = [];
            this.display_user_event = true;
            console.log(error.request);
          });
      }
      if (this.loadGroepen) {
        this.group_events = this.filterEventsByDate(this.group_events);
      } else {
        this.committee_events = this.filterEventsByDate(this.committee_events);
      }
    },
  },
  async mounted() {
    await this.$store.dispatch("get", "/api/v1/today").then((response) => {
      this.today = response.data.today;
    });

    // get commissies
    await this.$store
      .dispatch("get", "/api/v1/committees/parent_id/3")
      .then((data) => {
        this.committees = data.data.data;
      })
      .catch((error) => {
        console.log(error.request);
      });

    // get groups
    await this.$store
      .dispatch("get", "/api/v1/committees/parent_id/2")
      .then((data) => {
        this.groups = data.data.data;
      })
      .catch((error) => {
        console.log(error.request);
      });

    await this.$store
      .dispatch("get", "/api/v1/users")
      .then((data) => {
        this.users = data.data.data.filter((user) => {
          return (
            user.member_end == null ||
            moment(user.member_end).isAfter(moment(this.today))
          );
        });
      })
      .catch((error) => {
        console.log(error.request);
      });

    this.selectGroup();
  },
  computed: {
    getAttendees() {
      // remove duplicate
      var temp = this.all_events_attendees;

      var flags = [],
        output = [],
        l = temp.length,
        i;
      for (i = 0; i < l; i++) {
        if (flags[temp[i].id]) continue;
        flags[temp[i].id] = true;
        output.push(temp[i]);
      }

      //
      return output.filter((item) => {
        return this.selected_user_id == 0
          ? true
          : item.id == this.selected_user_id;
      });
    },
    activeMembers: function() {
      if (this.members.length > 0) {
        return this.members.filter(() => {
          return true;
        }).length;
      }
      return 0;
    },
    filterMembers: function() {
      if (this.members.length > 0 && this.query) {
        return this.members.filter((member) => {
          if (!member) {
            return false;
          }
          if (!member.display_name) {
            return false;
          }
          if (member.display_name && member.firstname && member.lastname) {
            return (
              member.display_name
                .toLowerCase()
                .match(this.query.toLowerCase()) ||
              member.firstname.toLowerCase().match(this.query.toLowerCase()) ||
              member.lastname.toLowerCase().match(this.query.toLowerCase())
            );
          } else if (member.display_name && member.firstname) {
            return (
              member.display_name
                .toLowerCase()
                .match(this.query.toLowerCase()) ||
              member.firstname.toLowerCase().match(this.query.toLowerCase())
            );
          } else if (member.display_name && member.lastname) {
            return (
              member.display_name
                .toLowerCase()
                .match(this.query.toLowerCase()) ||
              member.lastname.toLowerCase().match(this.query.toLowerCase())
            );
          } else {
            return member.display_name
              .toLowerCase()
              .match(this.query.toLowerCase());
          }
        });
      } else if (this.members.length > 0) {
        return this.members;
      } else {
        return [];
      }
    },
  },
  created() {
    this.$store.dispatch("get", "/api/v1/active/users").then((data) => {
      this.members = data.data.data;
    });
  },
  filters: {
    formatDate(value) {
      if (!isNaN(Date.parse(value))) {
        return moment(new Date(value)).format("DD-MM-YYYY HH:mm");
      }
      return value;
    },
  },
};
</script>

<style scoped>
.search-box {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #292929;
  border-radius: 4px;
  height: 40px;
  width: 20rem;
}

.search-btn {
  background: transparent;
  border: unset;
  margin-left: -30px;

  -webkit-appearance: none;
}

.btn {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 18px !important;
}

.custom-row {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
  opacity: 1;
}

.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;

  opacity: 1;
}

.flex-body {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 1 1 18%;
  height: auto;
  margin: 4px;
  padding: 20px 0;
  width: auto;
}
</style>
